// extracted by mini-css-extract-plugin
export default {"logo":"LogoDeskop_logo__LL9FP","shadow":"LogoDeskop_shadow__mOKS9"};